import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { app } from '../config/FirebaseConfig';
import { Box, Button, TextField, Typography, Alert, Paper } from '@mui/material';

const Login = () => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');
	const navigate = useNavigate();
	const auth = getAuth(app);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError('');
		try {
			await signInWithEmailAndPassword(auth, email, password);
			navigate('/'); // Go to guestlist (root route)
		} catch (err) {
			setError(err.message);
		}
	};

	return (
		<Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5">
			<Paper elevation={3} sx={{ p: 4, minWidth: 350 }}>
				<Typography variant="h5" mb={2} align="center" fontWeight={600}>
					Admin Login
				</Typography>
				<form onSubmit={handleSubmit}>
					<TextField
						label="Email"
						type="email"
						value={email}
						onChange={e => setEmail(e.target.value)}
						fullWidth
						required
						margin="normal"
						autoFocus
					/>
					<TextField
						label="Password"
						type="password"
						value={password}
						onChange={e => setPassword(e.target.value)}
						fullWidth
						required
						margin="normal"
					/>
					{error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
					<Button
						type="submit"
						variant="contained"
						color="primary"
						fullWidth
						sx={{ mt: 3, py: 1.2, fontWeight: 600 }}
					>
						Login
					</Button>
				</form>
			</Paper>
		</Box>
	);
};

export default Login;
